<template>
    <DatatablePageLayout>
        <template v-slot:actionButtons>
                <vs-button
                    class="rounded-lg xs:w-full sm:w-auto"
                    :to="{ name: 'create-zone' }" >
                    {{ $t("shared.add") }}
                </vs-button>
        </template>
        <template v-slot:datatable>
            <Datatable
                :config="datatableConfig"
                :elements="zones"
                :stripe="true"
                :draggable="true"
                :sst="true"
                :pagination="pagination"
                @action="action"
                @sort="sort"
            />
        </template>
    </DatatablePageLayout>
</template>

<script>

import ZonesService from '@/modules/Resorts/Services/ZonesService'
import Datatable from '@/modules/Shared/Components/table/SKDataTable.vue'
import loader from "@/modules/Shared/Mixins/loader";
import DatatablePageLayout from "@/modules/Shared/Pages/DatatablePageLayout"

export default {
    name: 'zones',
    mixins: [loader],
    components: {
        DatatablePageLayout,
        Datatable
    },
    data () {
        return {
            resortUuid: '',
            zones: [],
            datatableConfig: [
                { 'type': 'text', 'field': 'name', head: this.$t("resorts.webcams.name"), 'searchable': false, 'sortable': false },
                { 'type': 'actions', 'field': 'actions', head: this.$t("resorts.webcams.actions"), 'searchable': false, 'sortable': false }
            ],
            pagination: {},
        }
    },
    async created() {
        this.resortUuid = this.$route.params.uuid
        await this.getZones({})
    },
    methods: {
        async sort(sortedZones) {
            await ZonesService.sortZones(this.resortUuid, sortedZones)
        },
        async getZones(parameters) {
            this.zones = await ZonesService.getZones(this.resortUuid, parameters)
            this.pagination = {
                per_page: this.zones.per_page,
                total: this.zones.total
            }

            this.zones = this.zones.data.map(
                zone => ({...zone, 'actions': [ 'delete', 'edit' ]})
            )
        },
        action(type, uuid) {
            switch(type) {
                case 'edit':
                    this.$router.push({
                        name: 'edit-zone',
                        params: {
                            'zoneUuid': uuid
                        }
                    });
                break;
                case 'delete':
                    this.deleteZone(uuid)
                break;
            }
        },
        async deleteZone(uuid) {
            await this.loadAndNotify(async () => {
                await ZonesService.deleteZone(this.resortUuid, uuid)
                await this.getZones({})
            }, false)
        }
    }
}

</script>
